import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a363384"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  class: "bigBox",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "height": "100%"
  }
};
const _hoisted_4 = {
  class: "tag2Box"
};
const _hoisted_5 = {
  key: 0,
  class: "totalBox"
};
const _hoisted_6 = {
  class: "total"
};
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = {
  class: "num",
  style: {
    "color": "#056CFC"
  }
};
const _hoisted_9 = {
  class: "txt"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "total",
  style: {
    "opacity": "0"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "num",
  style: {
    "color": "#056CFC"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
})])])], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "total",
  style: {
    "opacity": "0"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "num",
  style: {
    "color": "#056CFC"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
})])])], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "total",
  style: {
    "opacity": "0"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "num",
  style: {
    "color": "#056CFC"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
})])])], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "total",
  style: {
    "opacity": "0"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "num",
  style: {
    "color": "#056CFC"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
})])])], -1));
const _hoisted_14 = {
  key: 1,
  class: "totalBox"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "total"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "num",
  style: {
    "color": "#056CFC"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  class: "txt"
})])])], -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "F8F9FF"
}, null, -1));
const _hoisted_18 = {
  class: "chartBox"
};
const _hoisted_19 = {
  class: "chartTabsBox"
};
const _hoisted_20 = {
  style: {
    "font-size": "18px",
    "margin-right": "10px"
  }
};
const _hoisted_21 = {
  class: "chartDad"
};
const _hoisted_22 = {
  class: "chartLeftBox"
};
const _hoisted_23 = {
  style: {
    "margin-bottom": "12px",
    "height": "45px"
  }
};
const _hoisted_24 = {
  style: {
    "min-height": "0",
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_25 = {
  class: "leftChart1",
  ref: "propChart1"
};
const _hoisted_26 = {
  class: "chartRightBox"
};
const _hoisted_27 = {
  style: {
    "margin-bottom": "12px",
    "height": "45px"
  }
};
const _hoisted_28 = {
  style: {
    "min-height": "0",
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_29 = {
  class: "leftChart1",
  ref: "propChart2"
};
const _hoisted_30 = {
  style: {
    "min-height": "0",
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_31 = {
  class: "leftChart1",
  ref: "propChart3"
};
const _hoisted_32 = {
  class: "listData"
};
const _hoisted_33 = {
  class: "listBox"
};
const _hoisted_34 = {
  class: "selectBox"
};
const _hoisted_35 = {
  class: "checkListBox"
};
const _hoisted_36 = {
  style: {
    "padding": "8px 12px",
    "max-height": "500px",
    "overflow-y": "auto"
  }
};
const _hoisted_37 = ["value"];
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "20px"
  }
}, null, -1));
const _hoisted_39 = {
  class: "store-status-lable storeStatusBox",
  style: {
    "background": "#808080",
    "cursor": "pointer"
  }
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载模板", -1));
const _hoisted_41 = {
  class: "upload-box"
};
const _hoisted_42 = {
  class: "upload-box-title"
};
const _hoisted_43 = {
  class: "upload-box-title-text"
};
const _hoisted_44 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_45 = {
  class: "upload-box-dashed"
};
const _hoisted_46 = {
  class: "upload-icon-group-box"
};
const _hoisted_47 = {
  class: "el-upload__text"
};
const _hoisted_48 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_49 = {
  class: "table"
};
const _hoisted_50 = {
  class: "hoverBorder"
};
const _hoisted_51 = ["onClick"];
const _hoisted_52 = {
  key: 0
};
const _hoisted_53 = {
  key: 1
};
const _hoisted_54 = {
  class: "bottom-pagination-box"
};
const _hoisted_55 = {
  class: "bigBox",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "height": "100%"
  }
};
const _hoisted_56 = {
  class: "tag2Box"
};
const _hoisted_57 = {
  class: "totalBox"
};
const _hoisted_58 = {
  class: "total"
};
const _hoisted_59 = {
  class: "num",
  style: {
    "color": "#056CFC"
  }
};
const _hoisted_60 = {
  class: "txt"
};
const _hoisted_61 = {
  class: "total"
};
const _hoisted_62 = {
  class: "num",
  style: {
    "color": "#00CB08"
  }
};
const _hoisted_63 = {
  class: "txt"
};
const _hoisted_64 = {
  class: "total"
};
const _hoisted_65 = {
  class: "num",
  style: {
    "color": "#FEBD30"
  }
};
const _hoisted_66 = {
  class: "txt"
};
const _hoisted_67 = {
  class: "total"
};
const _hoisted_68 = {
  class: "num",
  style: {
    "color": "#FF6057"
  }
};
const _hoisted_69 = {
  class: "txt"
};
const _hoisted_70 = {
  class: "total"
};
const _hoisted_71 = {
  class: "num",
  style: {
    "color": "#999999"
  }
};
const _hoisted_72 = {
  class: "txt"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "F8F9FF"
}, null, -1));
const _hoisted_74 = {
  class: "chartBox"
};
const _hoisted_75 = {
  class: "chartTabsBox"
};
const _hoisted_76 = {
  style: {
    "font-size": "18px",
    "margin-right": "10px"
  }
};
const _hoisted_77 = {
  class: "chartDad"
};
const _hoisted_78 = {
  class: "chartLeftBox"
};
const _hoisted_79 = {
  style: {
    "margin-bottom": "12px",
    "height": "45px"
  }
};
const _hoisted_80 = {
  style: {
    "min-height": "0",
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_81 = {
  class: "leftChart1",
  ref: "screenChart1"
};
const _hoisted_82 = {
  class: "chartRightBox"
};
const _hoisted_83 = {
  style: {
    "margin-bottom": "12px",
    "height": "45px"
  }
};
const _hoisted_84 = {
  style: {
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_85 = {
  class: "leftChart1",
  ref: "screenChart2"
};
const _hoisted_86 = {
  style: {
    "flex": "1",
    "display": "flex"
  }
};
const _hoisted_87 = {
  class: "leftChart1",
  ref: "screenChart3"
};
const _hoisted_88 = {
  class: "listData"
};
const _hoisted_89 = {
  class: "listBox"
};
const _hoisted_90 = {
  class: "selectBox"
};
const _hoisted_91 = {
  class: "screenListFilters"
};
const _hoisted_92 = {
  class: "checkListBox"
};
const _hoisted_93 = {
  style: {
    "padding": "8px 12px",
    "max-height": "500px",
    "overflow-y": "auto"
  }
};
const _hoisted_94 = ["value"];
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "20px"
  }
}, null, -1));
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "20px"
  }
}, null, -1));
const _hoisted_97 = {
  class: "statusGrid"
};
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载模板", -1));
const _hoisted_99 = {
  class: "upload-box"
};
const _hoisted_100 = {
  class: "upload-box-title"
};
const _hoisted_101 = {
  class: "upload-box-title-text"
};
const _hoisted_102 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_103 = {
  class: "upload-box-dashed"
};
const _hoisted_104 = {
  class: "upload-icon-group-box"
};
const _hoisted_105 = {
  class: "el-upload__text"
};
const _hoisted_106 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_107 = {
  class: "table"
};
const _hoisted_108 = {
  class: "hoverBorder"
};
const _hoisted_109 = ["onClick"];
const _hoisted_110 = {
  key: 0
};
const _hoisted_111 = {
  key: 1
};
const _hoisted_112 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原因", -1));
const _hoisted_113 = {
  class: "bottom-pagination-box"
};
const _hoisted_114 = {
  class: "imageBox"
};
const _hoisted_115 = {
  class: "image",
  style: {
    "width": "600px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "flex-start"
  }
};
const _hoisted_116 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin-left": "50px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_divider = _resolveComponent("a-divider");
  const _component_a_segmented = _resolveComponent("a-segmented");
  const _component_a_range_picker = _resolveComponent("a-range-picker");
  const _component_down_circle_outlined = _resolveComponent("down-circle-outlined");
  const _component_a_checkbox = _resolveComponent("a-checkbox");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_input_search = _resolveComponent("a-input-search");
  const _component_a_button = _resolveComponent("a-button");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_vxe_pager = _resolveComponent("vxe-pager");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_image = _resolveComponent("a-image");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_tabs, {
    class: "",
    activeKey: $setup.activeKey,
    "onUpdate:activeKey": _cache[30] || (_cache[30] = $event => $setup.activeKey = $event),
    size: "large",
    animated: false,
    onChange: $setup.tabsChange
  }, {
    default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
      key: "1",
      tab: _ctx.$t('screenManage.propSupplierData')
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$setup.screenData.storeLocationCount ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, _toDisplayString($setup.screenData.storeLocationCount), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('screenManage.total')), 1)])])]), _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2",
          "opacity": "0"
        }
      }), _hoisted_10, _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2",
          "opacity": "0"
        }
      }), _hoisted_11, _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2",
          "opacity": "0"
        }
      }), _hoisted_12, _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2",
          "opacity": "0"
        }
      }), _hoisted_13])) : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))]), _hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('screenManage.previewMode')), 1), _createTextVNode(), _createVNode(_component_a_segmented, {
        value: $setup.segmentedValue,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.segmentedValue = $event),
        options: $setup.segmentedData
      }, null, 8, ["value", "options"])]), _withDirectives(_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_a_range_picker, {
        value: $setup.dateValue,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.dateValue = $event),
        format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
        placeholder: [_ctx.$t('activityCreate.startTime'), _ctx.$t('activityCreate.endTime')],
        valueFormat: "YYYY-MM-DD",
        style: {
          "width": "265px"
        },
        onChange: $setup.onRangeChange
      }, null, 8, ["value", "placeholder", "onChange"])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, null, 512)])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_a_segmented, {
        value: $setup.chartValue,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.chartValue = $event),
        options: $setup.chartData,
        onChange: $setup.chartTabChangeLeft
      }, null, 8, ["value", "options", "onChange"])]), _withDirectives(_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, null, 512)], 512), [[_vShow, $setup.chartValue == 'pie']]), _withDirectives(_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, null, 512)], 512), [[_vShow, $setup.chartValue == 'bar']])])], 512), [[_vShow, $setup.segmentedValue == 'view']]), _withDirectives(_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", null, [_createVNode(_component_a_select, {
        value: $setup.screenData.storeTypeIds,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => $setup.screenData.storeTypeIds = $event),
        placeholder: _ctx.$t('storeManage.selectStoreType'),
        size: "middle",
        mode: "multiple",
        style: {
          "width": "200px"
        },
        "max-tag-count": 0,
        dropdownMatchSelectWidth: false,
        showArrow: true,
        "option-label-prop": "children",
        "max-tag-text-length": 8
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        dropdownRender: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createVNode(_component_a_checkbox, {
          checked: $setup.checkAll,
          onChange: $setup.onCheckAllChange,
          style: {
            "padding": "8px 12px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('storeManage.selectAll')), 1)]),
          _: 1
        }, 8, ["checked", "onChange"]), _createVNode(_component_a_divider, {
          style: {
            "margin": "0"
          }
        }), _createElementVNode("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.screenData.screenTypeList, item => {
          return _openBlock(), _createElementBlock("p", {
            key: item.storeTypeId,
            value: item.storeTypeId
          }, [_createVNode(_component_a_checkbox, {
            checked: $setup.screenData.storeTypeIds.includes(item.storeTypeId),
            onChange: $event => $setup.onCheckboxChange(item.storeTypeId, $event)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.storeTypeNameZh), 1)]),
            _: 2
          }, 1032, ["checked", "onChange"])], 8, _hoisted_37);
        }), 128))])])]),
        _: 1
      }, 8, ["value", "placeholder"]), _hoisted_38, _createVNode(_component_a_input_search, {
        value: $setup.searchKeyword,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.searchKeyword = $event),
        placeholder: _ctx.$t('screenManage.searchText'),
        style: {
          "width": "300px"
        },
        onSearch: $setup.onStatsSearch,
        allowClear: ""
      }, null, 8, ["value", "placeholder", "onSearch"]), _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('screenManage.NoInternet')), 1)]), _createElementVNode("div", null, [_createVNode(_component_a_button, {
        type: "link",
        color: "#539ce0",
        onClick: _cache[5] || (_cache[5] = $event => $setup.downLoadTaskModelClick(3))
      }, {
        default: _withCtx(() => [_hoisted_40]),
        _: 1
      }), _createVNode(_component_el_popover, {
        visible: $setup.uploadFilePopoverVisible1,
        placement: "bottom",
        trigger: "click",
        width: "auto",
        teleported: false,
        "popper-class": "upload-box-popper"
      }, {
        reference: _withCtx(() => [_createVNode(_component_a_button, {
          class: "sts-button default upload-file-btn",
          color: "black",
          onClick: $setup.openUploadFilePopover1,
          style: {
            "width": "80px",
            "height": "25px",
            "margin": "0px 10px",
            "padding": "0"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.fileUpload")), 1)]),
          _: 1
        }, 8, ["onClick"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("activityDetail.activityFileUpload")), 1), _createVNode(_component_svg_icon, {
          iconName: "close",
          iconColor: 'black',
          iconSize: "15px",
          style: {
            "cursor": "pointer",
            "padding": "3px"
          },
          onClick: _cache[6] || (_cache[6] = $event => $setup.uploadFilePopoverVisible1 = false)
        })]), _createVNode(_component_el_upload, {
          "on-exceed": $setup.handleFileExceed,
          class: "upload-pane",
          drag: "",
          ref: "uploadFile",
          action: $setup.uploadFileData.signatureData.host,
          "before-upload": $setup.handleFileBeforeUpload,
          "on-success": $setup.handleFileOnSuccess,
          data: $setup.uploadFileData.data,
          limit: 1,
          "file-list": $setup.uploadFileData.fileList
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createVNode(_component_a_button, {
            class: "sts-button default",
            color: "#539ce0",
            style: {
              "width": "80px",
              "padding": "0",
              "height": "25px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.browse")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_svg_icon, {
            iconName: "Excel",
            iconSize: "18px"
          }), _createVNode(_component_svg_icon, {
            iconName: "upload",
            iconSize: "18px"
          })]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityDetail.dragOrClickUpload")), 1), _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("activityDetail.supportFileType")), 1)])])])]),
          _: 1
        }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_a_button, {
        class: "sts-button default",
        color: "#539ce0",
        style: {
          "width": "80px",
          "height": "25px",
          "padding": "0"
        },
        onClick: _cache[7] || (_cache[7] = $event => $setup.exportTaskModelClick(2))
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('screenManage.export')), 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_49, [_createVNode(_component_vxe_table, {
        border: false,
        stripe: "",
        size: "small",
        class: "column-sort",
        ref: "storeTable",
        height: "auto",
        data: $setup.screenData.screenList,
        loading: $setup.storeLoading,
        "loading-config": {
          icon: 'vxe-icon-indicator roll',
          text: ' '
        },
        "row-config": {
          isHover: true
        },
        "sort-config": {
          showIcon: false
        },
        onHeaderCellClick: $setup.headerCellClickEvent,
        onScroll: $setup.handleScroll,
        "row-class-name": 'borderLeftGray'
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          "min-width": "350",
          field: "storeName",
          title: _ctx.$t('storeManage.storeName'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", _hoisted_50, _toDisplayString(row.storeName), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "150",
          field: "storeTypeNameZh",
          title: _ctx.$t('storeManage.storeType'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.storeTypeNameZh), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "200",
          field: "storeLocationName",
          title: _ctx.$t('screenManage.locationName'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", {
            style: {
              "color": "#0763db",
              "cursor": "pointer"
            },
            onClick: $event => $setup.storeClickEvent2(row)
          }, _toDisplayString(row.storeLocationName), 9, _hoisted_51)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "100",
          field: "xy",
          title: _ctx.$t('screenManage.resolution'),
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.resolutionWidth + ' x ' + row.resolutionHeight), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "350",
          field: "videoTaskName",
          title: _ctx.$t('screenManage.activityName'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [row.videoTaskName ? (_openBlock(), _createElementBlock("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.videoTaskName, (x, index) => {
            return _openBlock(), _createElementBlock("span", null, _toDisplayString(x), 1);
          }), 256))])) : (_openBlock(), _createElementBlock("div", _hoisted_53))]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "100",
          field: "contentManager",
          title: _ctx.$t('screenManage.contentManagement'),
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.contentManager ? row.contentManager : ''), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "100",
          field: "storeLocationVendorName",
          title: _ctx.$t('screenManage.screenSupplier'),
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.storeLocationVendorName ? row.storeLocationVendorName : ''), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "200",
          field: "installationDate",
          title: _ctx.$t('screenManage.installationTime'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.installationDate ? row.installationDate : ""), 1)]),
          _: 1
        }, 8, ["title"])]),
        _: 1
      }, 8, ["data", "loading", "onHeaderCellClick", "onScroll"])]), _createElementVNode("div", _hoisted_54, [_createVNode(_component_vxe_pager, {
        class: "sts-pager",
        background: "",
        "page-size": $setup.storeData.paginationData.pageSize,
        "onUpdate:pageSize": _cache[8] || (_cache[8] = $event => $setup.storeData.paginationData.pageSize = $event),
        "current-page": $setup.storeData.paginationData.currentPage,
        "onUpdate:currentPage": _cache[9] || (_cache[9] = $event => $setup.storeData.paginationData.currentPage = $event),
        "pager-count": 5,
        total: $setup.storeData.paginationData.totalSize,
        "page-sizes": $setup.storeData.paginationData.pageSizes,
        layouts: ['Total']
      }, null, 8, ["page-size", "current-page", "total", "page-sizes"])])])], 512), [[_vShow, $setup.segmentedValue == 'list']])])])]),
      _: 1
    }, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
      key: "2",
      tab: _ctx.$t('screenManage.screenSupplierData')
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", {
        class: "text",
        onClick: _cache[10] || (_cache[10] = $event => $setup.statusClick(null)),
        style: {
          "cursor": "pointer"
        }
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_59, _toDisplayString($setup.screenData.storeLocationCountPing.totalCount), 1), _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('screenManage.total')), 1)])])]), _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2"
        }
      }), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", {
        class: "text",
        onClick: _cache[11] || (_cache[11] = $event => $setup.statusClick(1)),
        style: {
          "cursor": "pointer"
        }
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_62, _toDisplayString($setup.screenData.storeLocationCountPing.onlineCount), 1), _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t('screenManage.online')), 1)])])]), _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2"
        }
      }), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", {
        class: "text",
        onClick: _cache[12] || (_cache[12] = $event => $setup.statusClick(2)),
        style: {
          "cursor": "pointer"
        }
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_65, _toDisplayString($setup.screenData.storeLocationCountPing.offlineCount), 1), _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('screenManage.offline')), 1)])])]), _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2"
        }
      }), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", {
        class: "text",
        onClick: _cache[13] || (_cache[13] = $event => $setup.statusClick(4)),
        style: {
          "cursor": "pointer"
        }
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_68, _toDisplayString($setup.screenData.storeLocationCountPing.failureCount), 1), _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('screenManage.fault')), 1)])])]), _createVNode(_component_a_divider, {
        type: "vertical",
        style: {
          "height": "60px",
          "background-color": "#E2E2E2"
        }
      }), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", {
        class: "text",
        onClick: _cache[14] || (_cache[14] = $event => $setup.statusClick(3)),
        style: {
          "cursor": "pointer"
        }
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_71, _toDisplayString($setup.screenData.storeLocationCountPing.disconnectCount), 1), _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('screenManage.totalFault')), 1)])])])])]), _hoisted_73, _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t('screenManage.previewMode')), 1), _createTextVNode(), _createVNode(_component_a_segmented, {
        value: $setup.segmentedValue,
        "onUpdate:value": _cache[15] || (_cache[15] = $event => $setup.segmentedValue = $event),
        options: $setup.segmentedData
      }, null, 8, ["value", "options"])]), _withDirectives(_createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createVNode(_component_a_range_picker, {
        value: $setup.dateValue2,
        "onUpdate:value": _cache[16] || (_cache[16] = $event => $setup.dateValue2 = $event),
        format: ['YYYY-MM-DD', 'YYYY-MM-DD'],
        placeholder: [_ctx.$t('activityCreate.startTime'), _ctx.$t('activityCreate.endTime')],
        valueFormat: "YYYY-MM-DD",
        style: {
          "width": "265px"
        },
        onChange: $setup.onRangeChange2
      }, null, 8, ["value", "placeholder", "onChange"])]), _createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, null, 512)])]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createVNode(_component_a_segmented, {
        value: $setup.chartValue,
        "onUpdate:value": _cache[17] || (_cache[17] = $event => $setup.chartValue = $event),
        options: $setup.chartData,
        onChange: $setup.chartTabChangeRight
      }, null, 8, ["value", "options", "onChange"])]), _withDirectives(_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, null, 512)], 512), [[_vShow, $setup.chartValue == 'pie']]), _withDirectives(_createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, null, 512)], 512), [[_vShow, $setup.chartValue == 'bar']])])], 512), [[_vShow, $setup.segmentedValue == 'view']]), _withDirectives(_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createVNode(_component_a_select, {
        value: $setup.screenData.storeTypeIds2,
        "onUpdate:value": _cache[18] || (_cache[18] = $event => $setup.screenData.storeTypeIds2 = $event),
        placeholder: _ctx.$t('storeManage.selectStoreType'),
        size: "middle",
        mode: "multiple",
        style: {
          "width": "200px"
        },
        "max-tag-count": 0,
        dropdownMatchSelectWidth: false,
        showArrow: true,
        "option-label-prop": "children",
        "max-tag-text-length": 8
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        dropdownRender: _withCtx(() => [_createElementVNode("div", _hoisted_92, [_createVNode(_component_a_checkbox, {
          checked: $setup.checkAll2,
          onChange: $setup.onCheckAllChange2,
          style: {
            "padding": "8px 12px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('storeManage.selectAll')), 1)]),
          _: 1
        }, 8, ["checked", "onChange"]), _createVNode(_component_a_divider, {
          style: {
            "margin": "0"
          }
        }), _createElementVNode("div", _hoisted_93, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.screenData.screenTypeList, item => {
          return _openBlock(), _createElementBlock("p", {
            key: item.storeTypeId,
            value: item.storeTypeId
          }, [_createVNode(_component_a_checkbox, {
            checked: $setup.screenData.storeTypeIds2.includes(item.storeTypeId),
            onChange: $event => $setup.onCheckboxChange2(item.storeTypeId, $event)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.storeTypeNameZh), 1)]),
            _: 2
          }, 1032, ["checked", "onChange"])], 8, _hoisted_94);
        }), 128))])])]),
        _: 1
      }, 8, ["value", "placeholder"]), _hoisted_95, _createVNode(_component_a_select, {
        value: $setup.screenData.venderId2,
        "onUpdate:value": _cache[19] || (_cache[19] = $event => $setup.screenData.venderId2 = $event),
        placeholder: _ctx.$t('screenManage.screenSupplier'),
        size: "middle",
        class: "vendorSelectCompact",
        dropdownMatchSelectWidth: false,
        showArrow: true,
        allowClear: "",
        onChange: $setup.onVendorChange2
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.screenData.screenVendorList, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.vendorId,
            value: item.vendorId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorName), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "placeholder", "onChange"]), _hoisted_96, _createVNode(_component_a_input_search, {
        value: $setup.searchKeyword2,
        "onUpdate:value": _cache[20] || (_cache[20] = $event => $setup.searchKeyword2 = $event),
        placeholder: _ctx.$t('screenManage.searchText'),
        style: {
          "width": "300px"
        },
        onSearch: $setup.onStatsSearch2,
        allowClear: ""
      }, null, 8, ["value", "placeholder", "onSearch"]), _createElementVNode("div", _hoisted_97, [_createElementVNode("span", {
        class: "store-status-lable storeStatusBox statusGridItem",
        style: {
          "background": "#29C93F",
          "cursor": "pointer"
        },
        onClick: _cache[21] || (_cache[21] = $event => $setup.statusClick(1))
      }, _toDisplayString(_ctx.$t('screenManage.online')), 1), _createElementVNode("span", {
        class: "store-status-lable storeStatusBox statusGridItem",
        style: {
          "background": "#FEBD30",
          "cursor": "pointer"
        },
        onClick: _cache[22] || (_cache[22] = $event => $setup.statusClick(2))
      }, _toDisplayString(_ctx.$t('screenManage.offline')), 1), _createElementVNode("span", {
        class: "store-status-lable storeStatusBox statusGridItem",
        style: {
          "background": "#FF6057",
          "cursor": "pointer"
        },
        onClick: _cache[23] || (_cache[23] = $event => $setup.statusClick(4))
      }, _toDisplayString(_ctx.$t('screenManage.fault')), 1), _createElementVNode("span", {
        class: "store-status-lable storeStatusBox statusGridItem",
        style: {
          "background": "#808080",
          "cursor": "pointer"
        },
        onClick: _cache[24] || (_cache[24] = $event => $setup.statusClick(3))
      }, _toDisplayString(_ctx.$t('screenManage.NoInternet')), 1)])]), _createElementVNode("div", null, [_createVNode(_component_a_button, {
        type: "link",
        color: "#539ce0",
        onClick: _cache[25] || (_cache[25] = $event => $setup.downLoadTaskModelClick(3))
      }, {
        default: _withCtx(() => [_hoisted_98]),
        _: 1
      }), _createVNode(_component_el_popover, {
        visible: $setup.uploadFilePopoverVisible,
        placement: "bottom",
        trigger: "click",
        width: "auto",
        teleported: false,
        "popper-class": "upload-box-popper"
      }, {
        reference: _withCtx(() => [_createVNode(_component_a_button, {
          class: "sts-button default upload-file-btn",
          color: "black",
          onClick: $setup.openUploadFilePopover,
          style: {
            "width": "80px",
            "height": "25px",
            "margin": "0px 10px",
            "padding": "0"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.fileUpload")), 1)]),
          _: 1
        }, 8, ["onClick"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [_createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.$t("activityDetail.activityFileUpload")), 1), _createVNode(_component_svg_icon, {
          iconName: "close",
          iconColor: 'black',
          iconSize: "15px",
          style: {
            "cursor": "pointer",
            "padding": "3px"
          },
          onClick: _cache[26] || (_cache[26] = $event => $setup.uploadFilePopoverVisible = false)
        })]), _createVNode(_component_el_upload, {
          "on-exceed": $setup.handleFileExceed,
          class: "upload-pane",
          drag: "",
          ref: "uploadFile",
          action: $setup.uploadFileData.signatureData.host,
          "before-upload": $setup.handleFileBeforeUpload,
          "on-success": $setup.handleFileOnSuccess,
          data: $setup.uploadFileData.data,
          limit: 1,
          "file-list": $setup.uploadFileData.fileList
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_102, [_createVNode(_component_a_button, {
            class: "sts-button default",
            color: "#539ce0",
            style: {
              "width": "80px",
              "padding": "0",
              "height": "25px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("activityDetail.browse")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, [_createVNode(_component_svg_icon, {
            iconName: "Excel",
            iconSize: "18px"
          }), _createVNode(_component_svg_icon, {
            iconName: "upload",
            iconSize: "18px"
          })]), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("activityDetail.dragOrClickUpload")), 1), _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t("activityDetail.supportFileType")), 1)])])])]),
          _: 1
        }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
        _: 1
      }, 8, ["visible"]), _createVNode(_component_a_button, {
        class: "sts-button default",
        color: "#539ce0",
        style: {
          "width": "80px",
          "height": "25px",
          "padding": "0"
        },
        onClick: _cache[27] || (_cache[27] = $event => $setup.exportTaskModelClick(3))
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('screenManage.export')), 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_107, [_createVNode(_component_vxe_table, {
        border: false,
        stripe: "",
        size: "small",
        class: "column-sort",
        ref: "storeTable2",
        height: "auto",
        data: $setup.screenData.screenList2,
        loading: $setup.storeLoading,
        "edit-config": {
          trigger: 'click',
          mode: 'cell',
          showIcon: false,
          beforeEditMethod: $setup.beforeEditMethod
        },
        onEditClosed: $setup.editClosedEvent,
        "loading-config": {
          icon: 'vxe-icon-indicator roll',
          text: ' '
        },
        "row-config": {
          isHover: true
        },
        "sort-config": {
          showIcon: false
        },
        onHeaderCellClick: $setup.headerCellClickEvent2,
        onScroll: $setup.handleScroll2,
        "row-class-name": $setup.rowClassName
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          "min-width": "350",
          field: "storeName",
          title: _ctx.$t('storeManage.storeName'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", _hoisted_108, _toDisplayString(row.storeName), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "150",
          field: "storeTypeNameZh",
          title: _ctx.$t('storeManage.storeType'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.storeTypeNameZh), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "200",
          field: "storeLocationName",
          title: _ctx.$t('screenManage.locationName'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", {
            style: {
              "color": "#0763db",
              "cursor": "pointer"
            },
            onClick: $event => $setup.storeClickEvent(row)
          }, _toDisplayString(row.storeLocationName), 9, _hoisted_109)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "100",
          field: "xy",
          title: _ctx.$t('screenManage.resolution'),
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.resolutionWidth + ' x ' + row.resolutionHeight), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "350",
          field: "videoTaskName",
          title: _ctx.$t('screenManage.programTask'),
          "show-overflow": "",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [row.videoTaskName ? (_openBlock(), _createElementBlock("div", _hoisted_110, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.videoTaskName, (x, index) => {
            return _openBlock(), _createElementBlock("span", null, _toDisplayString(x), 1);
          }), 256))])) : (_openBlock(), _createElementBlock("div", _hoisted_111))]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "100",
          field: "contentManager",
          title: _ctx.$t('screenManage.contentManagement'),
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.contentManager ? row.contentManager : ''), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          "min-width": "100",
          field: "storeLocationVendorName",
          title: _ctx.$t('screenManage.screenSupplier'),
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.storeLocationVendorName ? row.storeLocationVendorName : ''), 1)]),
          _: 1
        }, 8, ["title"]), $setup.deviceOnlineStatus === 4 ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 0,
          "min-width": "250",
          field: "failReason",
          title: '原因',
          "edit-render": {
            name: 'input'
          },
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createVNode(_component_svg_icon, {
            iconName: "edit",
            iconSize: "20px"
          }), _hoisted_112]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.failReason), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          "min-width": "200",
          field: "installationDate",
          title: _ctx.$t('screenManage.lastConnectionTime'),
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.storeCode ? row.lastOnlineTime : ""), 1)]),
          _: 1
        }, 8, ["title"])]),
        _: 1
      }, 8, ["data", "loading", "edit-config", "onEditClosed", "onHeaderCellClick", "onScroll", "row-class-name"])]), _createElementVNode("div", _hoisted_113, [_createVNode(_component_vxe_pager, {
        class: "sts-pager",
        background: "",
        "page-size": $setup.storeData2.paginationData.pageSize,
        "onUpdate:pageSize": _cache[28] || (_cache[28] = $event => $setup.storeData2.paginationData.pageSize = $event),
        "current-page": $setup.storeData2.paginationData.currentPage,
        "onUpdate:currentPage": _cache[29] || (_cache[29] = $event => $setup.storeData2.paginationData.currentPage = $event),
        "pager-count": 5,
        total: $setup.storeData2.paginationData.totalSize,
        "page-sizes": $setup.storeData2.paginationData.pageSizes,
        layouts: ['Total']
      }, null, 8, ["page-size", "current-page", "total", "page-sizes"])])])], 512), [[_vShow, $setup.segmentedValue == 'list']])])])]),
      _: 1
    }, 8, ["tab"])]),
    _: 1
  }, 8, ["activeKey", "onChange"])])]), _createVNode(_component_a_modal, {
    open: $setup.open,
    "onUpdate:open": _cache[31] || (_cache[31] = $event => $setup.open = $event),
    title: _ctx.$t('screenManage.screenshotRecords'),
    width: "1000px",
    footer: null
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_114, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imageList, (x, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "imageDiv",
        key: index,
        style: {
          "width": "100%",
          "display": "flex",
          "justify-content": "flex-start",
          "margin-bottom": "50px"
        }
      }, [_createElementVNode("div", _hoisted_115, [_createVNode(_component_a_image, {
        src: 'https://wplayernew.aqual.com.cn/' + x.screenshotUploadedUrl,
        alt: "",
        style: {
          "max-width": "600px",
          "max-height": "200px"
        }
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_116, _toDisplayString(x.createTime), 1)]);
    }), 128))])]),
    _: 1
  }, 8, ["open", "title"])], 64);
}